import React from "react";
import Nav from "./Nav";
import ServicesSection from "./ServicesSection";
import FinalCTA from "./FinalCTA";
import Footer from "./Footer";

const ServicesPage = () => (
  <div className="App">
    <title>Expert AI Services — EffiGen LLC</title>
    <meta
      name="description"
      content="EffiGen LLC offers custom AI product development, AI optimization workshops, AI strategy development, AI readiness assessments, and leadership training."
    />
    <link rel="canonical" href="https://effigen.ai/services" />
    <Nav />
    <main>
      <ServicesSection />
      <FinalCTA />
    </main>
    <Footer />
  </div>
);

export default ServicesPage;
